<template>
  <!-- <v-app> -->
  <Navbar />

  <!-- Landing Component -->
  <!-- Centered Content Section -->
  <Landing />
  <!-- <v-container class="d-flex justify-center">
        <v-row class="ma-0" justify="center" align="center">
            <Card v-for="(card, index) in cards" :key="card.id" :title="card.title" :price="card.price"
                :subtitle="card.subtitle" :image="card.image" :cols="4" @click="goToCardDetail(card.id)" />
        </v-row>
    </v-container> -->
  <!-- <v-container>


  <v-row>
    <v-col v-for="(item, index) in items" :key="index" cols="12" sm="6" md="4">
      <v-card class="modern-card" hover>
        <v-img :src="item.image" height="200px" contain class="image"></v-img>
         <v-card-actions class="actions">
        <v-btn ><RouterLink :to="{ name: 'serviceProduct', params: { id: item.slug } }" class="action-btn">{{ item.name }}</RouterLink></v-btn>
       
        </v-card-actions>
      </v-card>
    </v-col>
   
  </v-row>

</v-container> -->
  <v-container class="pa-4 mt-10 mx-auto ">
    <v-row ref="scrollRow" class="scroll-row ">
      <!-- <v-col v-for="(item, index) in items" :key="index" class="scroll-item mb-7 " cols="12" sm="6" md="4">
        <RouterLink :to="{ name: 'serviceProduct', params: { id: item.slug } }" class="text-decoration-none">
          <v-card class="modern-card position-relative">
            <v-img transition="slide-x-transition" :src="item.image" height="300px" contain class="image"></v-img>
            <div class="card-box">
              <h3 class="mb-0 text-center">{{ item.name }}</h3>
            </div>
          </v-card>
        </RouterLink>
      </v-col> -->
      <v-col v-for="(item, index) in serviceCards" :key="index" class="scroll-item mb-7" cols="12" sm="6" md="4">
        <!-- Optional: wrap in router-link if navigation is needed -->
        <RouterLink :to="{ name: 'serviceProduct', params: { id: item.id } }" class="text-decoration-none">
          <v-card class="modern-card ">
            <!-- <v-img transition="slide-x-transition" :src="getImage(item.image)
            " height="300px"  contain class="image"></v-img> -->
            <v-img transition="slide-x-transition" :src="item.image" class="image"></v-img>
            <!-- <v-img transition="slide-x-transition" :src="item.image
            "aspect-ratio="1" cover class="image"></v-img> -->

            <div class="card-box">
              <h3 class="mb-0 text-center">{{ item.title }}</h3>
            </div>
          </v-card>

        </RouterLink>
      </v-col>

    </v-row>
  </v-container>


  <HowWork />
  <WhyUs />
  <Footer />
  <!-- </v-app> -->
</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref, onMounted } from "vue";
import { serviceCard } from '@/services/apiServices.js'
import { apiConfig } from "@/config/apiConfig";
import banner1 from "@/assets/images/administrator.jpg";
// import cardImage6 from '@/assets/images/image (4).png';

import Navbar from '@/components/Navbar.vue';
import Landing from '@/components/Landing.vue';
import Card from '@/components/resuable/card.vue';
import HowWork from '@/components/HomeCompoent/HowWork.vue';
import WhyUs from '@/components/HomeCompoent/WhyUs.vue';
import Footer from '@/components/SharedUI/Footer.vue'

import { cards } from '@/Store/data/cards.js'

const error = ref("");
const serviceCards = ref("");

// const getImage = (item) => {
//   return item ? `${apiConfig.imageUrl}${item}` : banner1;
// };

// import { getCurrentInstance } from 'vue';
// const { appContext } = getCurrentInstance();
// const getImage = appContext.config.globalProperties.$getImage;

const fetchServicesCard = async () => {
  try {
    const data = await serviceCard();
    serviceCards.value = data;
  } catch (err) {
    error.value = err.response?.data?.message || "Failed to load classes";
    console.error("Error fetching class details:", err);
  }
};

const router = useRouter();

//Navigate to the specific card's detail page 
const goToCardDetail = (id) => {
  router.push({ name: 'id-card', params: { id } });
  // console.log("ID:::", id)
}

onMounted(fetchServicesCard);

</script>

<style scoped>
/* .modern-card {
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: visible;
  transition: transform 0.9s ease, box-shadow 0.3s ease;
  background-color: #fff;
  
  height: 100%;
}  */

.modern-card {
  display: flex;
  flex-direction: column;
  position: relative;
   padding: 0;
  overflow: visible;
  border-radius: 15px;
  box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.card-box {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 50px);
}

.modern-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.image {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover; /* optional - for better cropping */
  border-radius: 0;
  margin: 0;
}


.title {
  font-size: 1.25rem;
  font-weight: 700;
  text-align: center;
  padding: 16px;
  color: #333;
  background-color: #f8f8f8;
  text-transform: uppercase;
}



.actions {
  position: absolute;
  bottom: -5px;
  /* Moves button outside the box */
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  display: flex;
  justify-content: center;
}


.action-btn {
  background-color: #5761e7;
  color: white;
  font-weight: bold;
  padding: 10px 18px;
  border-radius: 30px;
  text-transform: uppercase;
  box-shadow: none;
  transition: background 0.3s ease, transform 0.3s ease;
  text-decoration: none;
  display: inline-block;

}

.action-btn:hover {
  /* background-color: #5761e7;
  transform: scale(1.05); */
}
</style>
